"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TAB_TYPE_TO_LINK_TYPE = exports.MENU_LINK_URL_MAP = exports.MENU_LINK_OPTIONS = exports.MENU_BAR_MIN_ENABLED_ERROR = exports.MENU_BAR_MIN_ENABLED = exports.MENU_BAR_MIN_COUNT = exports.MENU_BAR_MAX_ENABLED_ERROR = exports.MENU_BAR_MAX_ENABLED = exports.MENU_BAR_MAX_COUNT = exports.MENU_BAR_IMAGE_TIP = exports.MENU_BAR_IMAGE_SIZE_ERROR = exports.LINK_TYPE_TO_TAB_TYPE = void 0;
exports.apiMenuItemToUi = apiMenuItemToUi;
exports.createDefaultMenuItem = createDefaultMenuItem;
exports.createDefaultMenuList = createDefaultMenuList;
exports.getLinkUrlByType = getLinkUrlByType;
exports.linkTypeToTabType = linkTypeToTabType;
exports.normalizeMenuList = normalizeMenuList;
exports.tabTypeToLinkType = tabTypeToLinkType;
exports.uiMenuItemToApi = uiMenuItemToApi;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
/** 底部菜单栏链接类型与跳转地址 */
var MENU_LINK_OPTIONS = exports.MENU_LINK_OPTIONS = [{
  label: '首页',
  value: 'home',
  linkUrl: '/pages/index/index'
}, {
  label: '分类',
  value: 'mall',
  linkUrl: '/pages/goods_menu/index'
}, {
  label: '购物车',
  value: 'cart',
  linkUrl: '/pages/order_addcart/order_addcart'
}, {
  label: '我的',
  value: 'mine',
  linkUrl: '/pages/user/index'
}, {
  label: '装修页',
  value: 'share',
  linkUrl: '/pages/activity_index/index'
}];
var MENU_LINK_URL_MAP = exports.MENU_LINK_URL_MAP = MENU_LINK_OPTIONS.reduce(function (map, opt) {
  map[opt.value] = opt.linkUrl;
  return map;
}, {});
function getLinkUrlByType(linkType) {
  return MENU_LINK_URL_MAP[linkType] || '';
}

/** tabType 与 linkType 互转：1首页 2商城 3购物车 4我的 5装修页 */
var TAB_TYPE_TO_LINK_TYPE = exports.TAB_TYPE_TO_LINK_TYPE = {
  1: 'home',
  2: 'mall',
  3: 'cart',
  4: 'mine',
  5: 'share'
};
var LINK_TYPE_TO_TAB_TYPE = exports.LINK_TYPE_TO_TAB_TYPE = {
  home: 1,
  mall: 2,
  cart: 3,
  mine: 4,
  share: 5
};
function tabTypeToLinkType(tabType) {
  return TAB_TYPE_TO_LINK_TYPE[Number(tabType)] || 'home';
}
function linkTypeToTabType(linkType) {
  return LINK_TYPE_TO_TAB_TYPE[linkType] || 1;
}
function apiMenuItemToUi() {
  var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var linkType = item.linkType || tabTypeToLinkType(item.tabType);
  var status = item.status != null ? item.status === 0 || item.status === false ? 0 : 1 : item.isEnabled === 0 ? 0 : 1;
  return {
    id: item.id,
    companyAppId: item.companyAppId,
    selectedIcon: item.selectedIcon || item.iconActive || '',
    unselectedIcon: item.unselectedIcon || item.iconInactive || '',
    title: item.title || item.tabTitle || '',
    linkType: linkType,
    linkUrl: item.linkUrl || getLinkUrlByType(linkType),
    linkId: item.linkId != null && item.linkId !== '' ? item.linkId : item.skinId != null ? item.skinId : '',
    benefitPackageKey: item.benefitPackageKey || '',
    offlineJumpId: item.offlineJumpId != null && item.offlineJumpId !== '' ? item.offlineJumpId : '',
    status: status,
    sort: item.sort
  };
}
function uiMenuItemToApi() {
  var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var linkType = item.linkType || 'home';
  var isShare = linkType === 'share';
  var payload = {
    tabTitle: (item.title || '').trim(),
    tabType: linkTypeToTabType(linkType),
    linkUrl: getLinkUrlByType(linkType) || item.linkUrl || '',
    iconActive: item.selectedIcon || '',
    iconInactive: item.unselectedIcon || '',
    isEnabled: item.status === 0 ? 0 : 1,
    sort: item.sort,
    benefitPackageKey: isShare ? String(item.benefitPackageKey || '').trim() : ''
  };
  if (item.id != null && item.id !== '') {
    payload.id = item.id;
  }
  if (isShare && item.linkId !== '' && item.linkId != null) {
    payload.skinId = Number(item.linkId);
  }
  if (isShare && item.offlineJumpId !== '' && item.offlineJumpId != null) {
    payload.offlineJumpId = Number(item.offlineJumpId);
  }
  return payload;
}
var MENU_BAR_MIN_COUNT = exports.MENU_BAR_MIN_COUNT = 2;
var MENU_BAR_MAX_COUNT = exports.MENU_BAR_MAX_COUNT = 6;
var MENU_BAR_MIN_ENABLED = exports.MENU_BAR_MIN_ENABLED = 2;
var MENU_BAR_MAX_ENABLED = exports.MENU_BAR_MAX_ENABLED = 5;
var MENU_BAR_IMAGE_TIP = exports.MENU_BAR_IMAGE_TIP = '建议上传分辨率为 58*58px 的图片，大小≤10KB';
var MENU_BAR_IMAGE_SIZE_ERROR = exports.MENU_BAR_IMAGE_SIZE_ERROR = '请上传大小≤10KB 的图片！';
var MENU_BAR_MIN_ENABLED_ERROR = exports.MENU_BAR_MIN_ENABLED_ERROR = '至少开启2个导航按钮!';
var MENU_BAR_MAX_ENABLED_ERROR = exports.MENU_BAR_MAX_ENABLED_ERROR = '同时打开只展示5个导航按钮!';
function createDefaultMenuItem() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var linkType = overrides.linkType || 'home';
  return _objectSpread(_objectSpread({
    selectedIcon: '',
    unselectedIcon: '',
    title: '',
    linkType: linkType,
    linkUrl: getLinkUrlByType(linkType),
    linkId: '',
    benefitPackageKey: '',
    offlineJumpId: '',
    status: 1
  }, overrides), {}, _defineProperty({}, "linkUrl", overrides.linkUrl || getLinkUrlByType(overrides.linkType || linkType)));
}
function createDefaultMenuList() {
  return [createDefaultMenuItem({
    title: '首页',
    linkType: 'home'
  }), createDefaultMenuItem({
    title: '分类',
    linkType: 'mall'
  }), createDefaultMenuItem({
    title: '购物车',
    linkType: 'cart'
  }), createDefaultMenuItem({
    title: '我的',
    linkType: 'mine'
  })];
}
function normalizeMenuList(list) {
  if (!Array.isArray(list) || !list.length) {
    return createDefaultMenuList();
  }
  return list.map(function (item, index) {
    var uiItem = apiMenuItemToUi(item);
    return _objectSpread(_objectSpread(_objectSpread({}, createDefaultMenuItem({
      linkType: uiItem.linkType
    })), uiItem), {}, {
      linkType: uiItem.linkType,
      linkUrl: uiItem.linkUrl || getLinkUrlByType(uiItem.linkType),
      status: uiItem.status === 0 ? 0 : 1,
      sort: uiItem.sort != null ? uiItem.sort : index
    });
  }).sort(function (a, b) {
    return (a.sort != null ? a.sort : 0) - (b.sort != null ? b.sort : 0);
  });
}